import React, { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { api } from "../../lib/api";
import { useToast } from "../../hooks/use-toast";
import { KeyRound, Save } from "lucide-react";

const AccountAdmin = () => {
  const { admin } = useAuth();
  const { toast } = useToast();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (next.length < 8) {
      toast({ title: "Password too short", description: "Use at least 8 characters." });
      return;
    }
    if (next !== confirm) {
      toast({ title: "Passwords don't match", description: "Please re-enter the new password." });
      return;
    }
    setLoading(true);
    try {
      await api.changePassword(current, next);
      toast({ title: "Password updated", description: "Use the new password next time you sign in." });
      setCurrent("");
      setNext("");
      setConfirm("");
    } catch (e) {
      toast({ title: "Couldn't update", description: e.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="text-sm uppercase tracking-wider text-[color:var(--muted)]">Account</div>
      <h1 className="mt-2 font-display text-3xl md:text-4xl font-semibold">Your account</h1>
      <p className="mt-3 text-[color:var(--ink-soft)] text-sm">Signed in as <strong>{admin?.email}</strong>.</p>

      <form
        onSubmit={onSubmit}
        className="mt-8 max-w-md p-6 md:p-8 rounded-[20px] bg-white border border-black/10"
      >
        <div className="flex items-center gap-2">
          <KeyRound className="w-5 h-5" />
          <h2 className="font-display text-xl font-semibold">Change password</h2>
        </div>
        <div className="mt-5 space-y-4">
          <PwField label="Current password" value={current} onChange={setCurrent} />
          <PwField label="New password" value={next} onChange={setNext} />
          <PwField label="Confirm new password" value={confirm} onChange={setConfirm} />
        </div>
        <button type="submit" disabled={loading} className="mt-6 mk-btn mk-btn-primary disabled:opacity-60">
          <Save className="w-4 h-4" /> {loading ? "Saving…" : "Save password"}
        </button>
      </form>
    </div>
  );
};

const PwField = ({ label, value, onChange }) => (
  <label className="block">
    <span className="text-xs font-medium uppercase tracking-wider text-[color:var(--muted)]">{label}</span>
    <input
      type="password"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="mt-1.5 w-full bg-transparent border-b border-black/25 focus:border-[color:var(--coral)] outline-none py-2.5 text-base transition-colors"
      required
    />
  </label>
);

export default AccountAdmin;
